export default "__VITE_PUBLIC_ASSET__e155cc90__"